import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Button, Checkbox, Grid, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from "@mui/material";
import { useAppDispatch } from "../../../stores/hooks";
import { useEffect, useState } from "react";
import { TocDataTables } from "../../../data/interfaces/configurationmodels";
import { DropdownModel, EditorType, TableInfo } from "../../../data/interfaces/sharedmodels";
import { TableChart as TableViewIcon, ExpandMore as ExpandMoreIcon, Clear } from '@mui/icons-material';
import configService from "../../../data/api/config.service";
import { showsuccessmessage, showwarningmessage } from "../../../stores/notificationslice";


export default function DataTableConfig() {
    // const dummyTocDataTables: TocDataTables = {
    //     DataTables: [
    //       {
    //           Id: 1, Description: "Table 1",
    //           Version: "",
    //           LastModified: "",
    //           IsGlobal: true,
    //           EditorType: EditorType.Acceptance,
    //           CanDeleteRows: false,
    //           MaxRowCount: null,
    //           MinRowCount: null,
    //           OpensInPopup: null,
    //           TicketTypeId: 1
    //       },
    //       {
    //           Id: 2, Description: "Table 2",
    //           Version: "",
    //           LastModified: "",
    //           IsGlobal: false,
    //           EditorType: EditorType.Acceptance,
    //           CanDeleteRows: false,
    //           MaxRowCount: null,
    //           MinRowCount: null,
    //           OpensInPopup: null,
    //           TicketTypeId: 1
    //       },
    //       {
    //           Id: 3, Description: "Table 3",
    //           Version: "",
    //           LastModified: "",
    //           IsGlobal: false,
    //           EditorType: EditorType.Acceptance,
    //           CanDeleteRows: false,
    //           MaxRowCount: null,
    //           MinRowCount: null,
    //           OpensInPopup: null,
    //           TicketTypeId: 2
    //       },
    //     ],
    //     TocDataTables: [
    //       {
    //         TocId: 1,
    //         TocName: "TOC 1",
    //         TocToDataTables: [
    //           { Id: 1, DataTableId: 1, Description: "Description 1", IsDeleted: false },
    //           { Id: 2, DataTableId: 2, Description: "Description 2", IsDeleted: false },
    //         ]
    //       },
    //       {
    //         TocId: 2,
    //         TocName: "TOC 2",
    //         TocToDataTables: [
    //           { Id: 3, DataTableId: 3, Description: "Description 3", IsDeleted: true },
    //         ]
    //       }
    //     ]
    //   };

    const dispatch = useAppDispatch();
    const [tocDatatables, setTocDatatable] = useState<TocDataTables>({ DataTables: [], TocDataTablesList: [] });
    //const [tocDatatables, setTocDatatable] = useState<TocDataTables>(dummyTocDataTables);
    const [selectedToc, setSelectedToc] = useState<number>(0);
    const [selectedType, setSelectedType] = useState<number>(0);

    useEffect(() => {
        loadTocdatatables();

    }, []);

    const loadTocdatatables = () => {
        configService.GetTocDataTables().then((response) => {
            setTocDatatable(response.data);
        });
    }


    useEffect(() => {
        if (tocDatatables && tocDatatables.DataTables.length && selectedToc < 1) {
            setSelectedToc(tocDatatables.TocDataTablesList[0].TocId);
            setSelectedType(1);
        }
    }, [tocDatatables]);


    const handleSave = () => {

        if (tocDatatables.TocDataTablesList.findIndex(a => a.TocToDataTables.findIndex(b => (b.Id == null && !b.IsDeleted) || (b.Id != null && b.IsDeleted)) > -1) < 0) {
            dispatch(showwarningmessage("No data has changed.")); return;
        }

        let tocDatatable = tocDatatables.TocDataTablesList.filter(a => a.TocToDataTables.findIndex(b => (b.Id == null && !b.IsDeleted) || (b.Id != null && b.IsDeleted)) > -1);
        configService.UpdateTocDatatable(tocDatatable).then((response) => {
            loadTocdatatables();
            dispatch(showsuccessmessage("The datatable data saved successfully."));
        })
    }

    const handleOnToggleDataTable = (checked: boolean, datatable: TableInfo) => {

        let tempTocdatatables: TocDataTables = { ...tocDatatables };
        if (tempTocdatatables.TocDataTablesList && tempTocdatatables.TocDataTablesList.filter(a => a.TocId == selectedToc)[0]
            .TocToDataTables.findIndex(m => m.DataTableId == datatable.Id) > -1) {

            if (tempTocdatatables.TocDataTablesList.filter(a => a.TocId == selectedToc)[0]
                .TocToDataTables.filter(m => m.DataTableId == datatable.Id)[0].Id == null && checked == false) {
                tempTocdatatables.TocDataTablesList.filter(a => a.TocId == selectedToc)[0]
                    .TocToDataTables.filter(m => m.DataTableId == datatable.Id)[0].IsDeleted = !checked;
            }
            else if (checked == false) {
                dispatch(showwarningmessage("Data integrity would be compromised by this deletion. Change cannot be made. Contact the system adminstrator.")); return;
            }
            else {
                tempTocdatatables.TocDataTablesList.filter(a => a.TocId == selectedToc)[0]
                    .TocToDataTables.filter(m => m.DataTableId == datatable.Id)[0].IsDeleted = !checked;
            }
        }
        else {
            tempTocdatatables.TocDataTablesList?.filter(a => a.TocId == selectedToc)[0]
                .TocToDataTables.push({ Id: null, DataTableId: datatable.Id, Description: null, IsDeleted: false });
        }

        setTocDatatable(tempTocdatatables);
    }
    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        };

    const [expanded, setExpanded] = useState<string | false>('globaltables');
    const uniqueTicketTypeIds = [...new Set(tocDatatables.DataTables.map(datatable => datatable.TicketType))];
    return (
        <Box component={Paper} sx={{ mt: 2 }}>
            <Grid container spacing={2} >

                <Grid xs={4}>
                    <Box component={Paper} sx={{ml:2,  p: 2 }}>
                        <Typography variant="h6">TOCs</Typography>
                        <List disablePadding={true}>
                            {
                                selectedToc ? tocDatatables?.TocDataTablesList.map(function (toc) {
                                    return (
                                        <ListItemButton key={toc.TocId} selected={selectedToc === toc.TocId}
                                            onClick={(event) => setSelectedToc(toc.TocId)}>
                                            <ListItemText primary={toc.TocName} />
                                        </ListItemButton>)
                                })
                                    : null}
                        </List>
                    </Box>
                </Grid>
                <Grid xs={4}>
                    <Box component={Paper} sx={{  p: 2 }}>
                        <Typography variant="h6">Ticket Types</Typography>
                        <List disablePadding={true}>
                            {
                                selectedType ? uniqueTicketTypeIds.map(function (TicketTypeId) {
                                    return (
                                        <ListItemButton key={TicketTypeId} selected={selectedType === TicketTypeId}
                                            onClick={(event) => setSelectedType(TicketTypeId)}>
                                            <ListItemText primary={TicketTypeId == 1 ? 'Magnetic' : 'ITSO'} />
                                        </ListItemButton>)
                                })
                                    : null}
                        </List>
                    </Box>
                </Grid>
                <Grid xs={4}>
                    <Box component={Paper} sx={{  p: 2 }}>
                        <Typography variant="h6">DataTables</Typography>
                        {tocDatatables.DataTables.findIndex(a => a.IsGlobal) > -1 ?
                            <Accordion expanded={true} onChange={handleChange('globaltables')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="globaltables-content"
                                    id="globaltables-header"
                                >
                                    <Typography variant="h6">Global Tables</Typography>
                                </AccordionSummary>
                                <AccordionDetails>

                                    <List dense={true} disablePadding={true}>
                                        {
                                            tocDatatables && tocDatatables?.TocDataTablesList.length && selectedToc && selectedType ?
                                                tocDatatables.DataTables.filter(a => a.IsGlobal && selectedType === a.TicketType).map(function (table) {
                                                    return (
                                                        <ListItemButton >
                                                            <ListItemIcon>
                                                                <Checkbox
                                                                    edge="start"
                                                                    onChange={(e) => handleOnToggleDataTable(e.target.checked, table)}
                                                                    checked={tocDatatables?.TocDataTablesList.filter(a => a.TocId == selectedToc)[0].TocToDataTables.findIndex(b => b.DataTableId == table.Id && b.IsDeleted == false) > -1}
                                                                    tabIndex={-1}
                                                                    disableRipple
                                                                    inputProps={{ 'aria-labelledby': table.Description }} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={table.Description} />
                                                        </ListItemButton>)
                                                })
                                                : null}
                                    </List>
                                </AccordionDetails>
                            </Accordion> : null}
                        {tocDatatables.DataTables.findIndex(a => !a.IsGlobal) > -1 ?
                            <Accordion expanded={true} onChange={handleChange('stationtables')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="stationtables-content"
                                    id="stationtables-header"
                                >
                                    <Typography variant="h6">Station Specific Tables</Typography>
                                </AccordionSummary>
                                <AccordionDetails>

                                    <List dense={true} disablePadding={true}>
                                        {
                                            tocDatatables && tocDatatables?.TocDataTablesList.length && selectedToc && selectedType ? tocDatatables.DataTables.filter(a => !a.IsGlobal && selectedType === a.TicketType).map(function (table) {
                                                return (
                                                    <ListItemButton >
                                                        <ListItemIcon>
                                                            <Checkbox
                                                                edge="start"
                                                                onChange={(e) => handleOnToggleDataTable(e.target.checked, table)}
                                                                checked={tocDatatables?.TocDataTablesList.filter(a => a.TocId == selectedToc)[0].TocToDataTables.findIndex(b => b.DataTableId == table.Id && b.IsDeleted == false) > -1}
                                                                tabIndex={-1}
                                                                disableRipple
                                                                inputProps={{ 'aria-labelledby': table.Description }} />
                                                        </ListItemIcon>
                                                        <ListItemText primary={table.Description} />
                                                    </ListItemButton>)
                                            })
                                                : null}
                                    </List>
                                </AccordionDetails>
                            </Accordion> : null}
                    </Box>
                </Grid>
                <Grid xs={12}>
                    <Button variant="contained" sx={{ float: "right", m: 2 }} onClick={handleSave}>Save All Changes</Button>
                </Grid>
            </Grid>
        </Box>
    )
}